import { useFormik } from 'formik';
import { NavLink } from 'react-router-dom';
import useTemplates from './hooks/useTemplates';
import { Button } from '@/src/shadComponents/ui/button';
import { Input } from '@/src/shadComponents/ui/input';
import { Label } from '@/src/shadComponents/ui/label';
import {
    Card,
    CardContent,
} from '@/src/shadComponents/ui/card';
import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';
import PageShell from '@/src/Common/components/PageShell';

export default function UploadTemplate() {
    const { importTemplate } = useTemplates();
    const { orgId } = useUserOrg();
    const formik = useFormik({
        initialValues: {
            name: '',
            orgId: orgId.toString(),
        },
        onSubmit: importTemplate,
    });

    return (
        <PageShell
            title="Import Template"
            subtitle="The zip structure expects an index.html and an images directory containing all image assets."
            breadcrumbs={[
                { label: 'Email Templates', href: '/templates' },
                { label: 'Import' },
            ]}
        >
            <Card>
                <CardContent className="pt-6">
                    <form
                        onSubmit={formik.handleSubmit}
                        encType="multpart/form-data"
                        className="space-y-6"
                    >
                        <div className="space-y-2">
                            <Label htmlFor="name">Name</Label>
                            <Input
                                id="name"
                                name="name"
                                placeholder="Template name"
                                onChange={(e) => {
                                    formik.setFieldValue(
                                        'name',
                                        e.currentTarget.value,
                                    );
                                }}
                            />
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="zip">Template File</Label>
                            <Input
                                id="zip"
                                type="file"
                                name="zip"
                                accept="application/zip"
                                onChange={(e) => {
                                    formik.setFieldValue(
                                        'zip',
                                        e.currentTarget.files?.[0],
                                    );
                                }}
                            />
                        </div>

                        <div className="flex items-center justify-end gap-2">
                            <NavLink to="/templates">
                                <Button type="button" variant="outline">
                                    Cancel
                                </Button>
                            </NavLink>
                            <Button type="submit">Import</Button>
                        </div>
                    </form>
                </CardContent>
            </Card>
        </PageShell>
    );
}
